import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import About from '../views/About.vue'
import Login from '../views/Login.vue'
import Suppliers from '../views/Suppliers.vue'
import SupplierDetails from '../views/SupplierDetails.vue'
import Users from '../views/Users.vue'
import UserDetails from '../views/UserDetails.vue'
import Deliveries from '../views/Deliveries.vue'
// import DeliveryDetails from './views/DeliveryDetails.vue'
// import DeliveryDetails from '../views/DeliveryDetails2.vue'
// import DeliveryDetails2 from '../views/DeliveryDetails3.vue'
import Zones from '../views/Zones.vue'
import Companies from '../views/Companies'
import Settings from '../views/Settings'
import Gates from '../views/Gates';
import Resources from '../views/Resources';
import Units from '../views/Units';
import Simcards from '../views/Simcards';
import Manual from '../views/Manual';
import Calendar from '../views/Calendar.vue';
import Activities from '../views/Activities.vue';
import ActivitiesClaimed from '../views/ActivitiesClaimed.vue';
import Siteplan from '../views/Siteplan.vue';
// import GatesTcp from './views/GatesTcp.vue';
// import DeliveryDetails4 from '../views/DeliveryDetails4';
import DeliveryDetails5 from '../views/DeliveryDetails5';
import KeyGenerator from '../views/KeyGenerator';
import ContentManager from '../views/ContentManager';
import Infoscreen from '../views/Infoscreen';
import Agencies from '../views/Agencies';

import store from '../store/store.js';


Vue.use(Router)

const ifNotAuthenticated = (req, res, next) => {
    if (!store.getters.isAuthenticated) {
        next();
        return;
    }
    next('/');
};

const ifAuthenticated = (req, res, next) => {
    if (store.getters.isAuthenticated) {
        next();
        return;
    }

    next('/login');
};

let router = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Dashboard,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/about',
            name: 'about',
            component: About,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/supplier',
            name: 'suppliers',
            component: Suppliers,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/supplier/:id',
            props: true,
            name: 'supplier',
            component: SupplierDetails,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/user',
            name: 'users',
            component: Users,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/user/:id',
            props: true,
            name: 'user',
            component: UserDetails,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/delivery',
            name: 'deliveries',
            component: Deliveries,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/delivery/details/:id',
            props: true,
            name: 'deliverydetails',
            component: DeliveryDetails5,
            beforeEnter: ifAuthenticated
        },
        // {
        //     path: '/delivery/details2/:id',
        //     props: true,
        //     name: 'deliverydetails2',
        //     component: DeliveryDetails2,
        //     beforeEnter: ifAuthenticated
        // },
        // {
        //     path: '/delivery/details4/:id',
        //     props: true,
        //     name: 'deliverydetails4',
        //     component: DeliveryDetails4,
        //     beforeEnter: ifAuthenticated
        // },
        // {
        //     path: '/delivery/details5/:id',
        //     props: true,
        //     name: 'deliverydetails5',
        //     component: DeliveryDetails5,
        //     beforeEnter: ifAuthenticated
        // },
        {
            path: '/zone',
            name: 'zones',
            component: Zones,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/company',
            name: 'companies',
            component: Companies,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/gate',
            name: 'gates',
            component: Gates,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/resource',
            name: 'resources',
            component: Resources,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/unit',
            name: 'units',
            component: Units,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/simcard',
            name: 'simcards',
            component: Simcards,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/manual',
            name: 'manual',
            component: Manual,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: Calendar,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/activity',
            name: 'activities',
            component: Activities,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/activityclaimed',
            name: 'activitiesclaimed',
            component: ActivitiesClaimed,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/siteplan',
            name: 'siteplan',
            component: Siteplan,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/keygenerator',
            name: 'keygenerator',
            component: KeyGenerator,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/content',
            name: 'content',
            component: ContentManager,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/agencies',
            name: 'agencies',
            component: Agencies,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/infoscreen/:project/:id/:autorefresh',
            props: true,
            name: 'infoscreen',
            component: Infoscreen
            // beforeEnter: ifAuthenticated
        }
        // {
        //     path: '/gatetcp',
        //     name: 'gatestcp',
        //     component: GatesTcp,
        //     beforeEnter: ifAuthenticated
        // }
    ]
})

router.beforeEach((to, from, next) => {
    store.dispatch("isVersionOk");
    if(to.path === "/login" || to.name === "infoscreen") {
        next();
        return;
    }

    let isAuthed = store.getters.isAuthenticated;
    if (isAuthed) {
        next();
        return;
    }
    else{
        next('/login');
        return;
    }
})

export default router;